import { getChakraVarExpression } from './chakraVar';
export const ModalBackground = [
    // utilize coordinate system of svg gradient
    `${getChakraVarExpression('colors', 'gradientsInSvg.modalBg')} left top / 100% 100% padding-box no-repeat`,
    'linear-gradient(0deg, #152C4B 0%, #081020 100%) border-box',
].join(',');
